import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const APP_NAME = "Worksite Manager";

const routes = [
  { pattern: /^\/$/, title: "Dashboard", description: "Worksite pack dashboard." },
  { pattern: /^\/login\/?$/, title: "Sign in", description: "Sign in to Worksite Manager." },
  { pattern: /^\/packs\/resume\/?$/, title: "Create or resume pack", description: "Start a worksite pack or resume a saved draft." },
  { pattern: /^\/packs\/create(?:\/[^/]+)?\/?$/, title: "Create pack", description: "Create or update a worksite pack." },
  { pattern: /^\/packs\/register\/?$/, title: "Packs register", description: "Search, filter and manage worksite packs." },
  { pattern: /^\/packs\/exports\/?$/, title: "Data exports", description: "Download completed pack-register exports." },
  { pattern: /^\/view\/[^/]+\/reassign\/?$/, title: "Reassign Engineering Supervisors", description: "Update Engineering Supervisor coverage for a worksite pack." },
  { pattern: /^\/view\/[^/]+\/?$/, title: "View pack", description: "View worksite pack details, exports and history." },
  { pattern: /^\/library\/elrs\/?$/, title: "ELRs", description: "Browse ELR mileage boundaries." },
  { pattern: /^\/(?:library\/swp-projects|library\/projects|projects)\/?$/, title: "SWP projects", description: "Browse SWP projects available for worksite packs." },
  { pattern: /^\/people\/?$/, title: "People", description: "Manage Worksite Manager users and roles." },
  { pattern: /^\/organisations\/?$/, title: "Organisations", description: "Manage organisations using Worksite Manager." },
];

export const setDocumentMetadata = (title, description) => {
  document.title = `${title} | ${APP_NAME}`;

  let descriptionElement = document.querySelector('meta[name="description"]');
  if (!descriptionElement) {
    descriptionElement = document.createElement("meta");
    descriptionElement.setAttribute("name", "description");
    document.head.appendChild(descriptionElement);
  }
  if (description) descriptionElement.setAttribute("content", description);
};

const RouteMetadata = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const route = routes.find(({ pattern }) => pattern.test(pathname));
    setDocumentMetadata(
      route?.title || "Page not found",
      route?.description || "The requested Worksite Manager page could not be found.",
    );
  }, [pathname]);

  return null;
};

export default RouteMetadata;
